import React, { useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Slot from "./slot";
import Playlist from "./playlist";
import NewSlot from "./NewSlot";
import EditSlot from "./EditSlot";
import RadioFile from "./RadioFile";
import NewRadioFile from "./NewRadioFile";
import EditRadioFile from "./EditRadioFile";

function Radio() {
  const [activeTab, setActiveTab] = useState("slot");
  const navigate = useNavigate();
  const location = useLocation();

  const getTabClass = (tab) => {
    return `btn ${activeTab === tab ? "btn btn-primary" : "btn btn-secondary"}`;
  };

  return (
    <div className="p-3">
      <div className="d-flex gap-2 mb-4">
        <button
          className={getTabClass("slot")}
          onClick={() => {
            setActiveTab("slot");
            navigate("/radio");
          }}
        >
          Slot
        </button>
        <button
          className={getTabClass("Radio File")}
          onClick={() => {
            setActiveTab("Radio File");
            navigate("/radio/file");
          }}
        >
          Radio File
        </button>
        {/* <button
          className={getTabClass("playlist")}
          onClick={() => {
            setActiveTab("playlist");
            navigate("/radio/playlist");
          }}
        >
          Playlist
        </button> */}
      </div>

      <Routes>
        <Route path="/" element={<Slot />} />
        <Route path="new-slot" element={<NewSlot />} />
        <Route path="file/new-radio" element={<NewRadioFile />} />
        <Route path="edit-slot/:slot_id" element={<EditSlot />} />
        <Route path="file/edit-file/:radio_audio_file_id" element={<EditRadioFile />} />
        <Route path="slot-playlist/:id" element={<Playlist />} />
        <Route path="file" element={<RadioFile />} />
      </Routes>
    </div>
  );
}

export default Radio;
